import { cn } from "@/lib/utils";
import * as React from "react";

type Variant = "default" | "secondary" | "outline" | "ghost" | "link" | "tertiary";

const variants: Record<Variant, string> = {
  default: "bg-primary text-on-primary hover:opacity-90 active:scale-[0.98]",
  secondary: "bg-secondary-container text-on-secondary-container hover:opacity-90",
  outline: "border border-outline bg-transparent text-on-surface hover:bg-surface-container",
  ghost: "text-on-surface-variant hover:bg-surface-container",
  link: "text-primary underline underline-offset-4 hover:opacity-80",
  tertiary: "bg-tertiary text-on-tertiary hover:opacity-90",
};

export const Button = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }
>(({ className, variant = "default", ...props }, ref) => (
  <button
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center rounded-full font-label-caps text-label-caps transition-all h-10 px-6",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
      "disabled:pointer-events-none disabled:opacity-50",
      variants[variant],
      className,
    )}
    {...props}
  />
));
Button.displayName = "Button";
